import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { COMMON_IMPORTS } from '../../common-imports';
import { ConsentFacade } from '../../../../Facades/consent.facade';

@Component({
  selector: 'av-consent-lock-banner',
  standalone: true,
  imports: [COMMON_IMPORTS],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './consent-lock-banner.component.html',
  styleUrl: './consent-lock-banner.component.scss',
})
export class ConsentLockBannerComponent {
  private readonly _consentFacade = inject(ConsentFacade);

  readonly visible = this._consentFacade.showRemedyBanner;

  onReturnToConsent(): void {
    this._consentFacade.returnToConsent();
  }
}
